import { render, staticRenderFns } from "./FMItemCard.vue?vue&type=template&id=558a7948&scoped=true"
import script from "./FMItemCard.vue?vue&type=script&lang=js"
export * from "./FMItemCard.vue?vue&type=script&lang=js"
import style0 from "./FMItemCard.vue?vue&type=style&index=0&id=558a7948&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "558a7948",
  null
  
)

export default component.exports